/** The order "Diagnose" tab — thin adapter over features/ai-diag (shared
 *  entity_diagnose backend tool; see the bookings variant). */
import { useMemo } from 'react';

import * as ordersApi from '@/api/orders';
import { AiDiagChat } from '@/features/ai-diag/AiDiagChat';
import type { AiDiagAdapter } from '@/features/ai-diag/types';

export function AiDiagnosePanel({ orderId, tenantId }: { orderId: number; tenantId?: number | null }) {
  const adapter: AiDiagAdapter = useMemo(
    () => ({
      launchContext: ordersApi.diagnoseLaunchContext,
      start: (body) => ordersApi.startDiagnose(orderId, body),
      taskType: 'entity_diagnose',
      subjectNoun: 'order',
      subjectTitle: `Order ${orderId}`,
      questionPlaceholder: 'e.g. "Why is this order still on hold?"',
      labelContains: `[order:${orderId}]`,
      matchesSubject: (params) => (params as { order_id?: number } | null)?.order_id === orderId,
      tenantId,
    }),
    [orderId, tenantId],
  );
  return (
    <AiDiagChat
      adapter={adapter}
      subjectNote={
        'The AI reads this order’s row, its bookings (with mobile-cache state), ' +
        'imports & webhooks, emitted events, tenant config, backend logs and the ' +
        'booking system’s current record — nothing else.'
      }
    />
  );
}
